import React from "react";

const DescriptionLabel = ({position, phase})=>{
    const mapLabel = {
        "winner": <>
                                <label style={{color:'white'}}>¿Quien fue el mejor jugador del año?</label>
</>,
        "nominate": <>
                    <p style={{color:'rgb(231, 175, 87)', fontSize:'25px', transition:'opacity 0.5s ease'}}>Selecciona 1 { position }</p>
                        <label style={{color:'white'}}>Solo busca y selecciona a tu { position} favorito</label></>,
    }
    return(
                    <div style={{display:'flex', justifyContent:'center', flexDirection:'column', alignItems:'center'}}>
                        {mapLabel?.[phase] || <p style={{color:'white'}}>Selecciona 1 { position }</p>}
        
                    </div>

    )
}


export default DescriptionLabel